export default "__VITE_ASSET__591a87de__"